import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Switch } from '@treams/treams-ui/common/Switch';

import Property from './Property';

function Party(props: { title: string; name: string; checked: boolean; onChange: () => void }) {
	return <Switch label={props.title} on={props.checked} onChange={() => props.onChange()} />;
}

export default function FilledInBy() {
	const { t } = useTranslation();

	const [field, , { setValue }] = useField('fillInBy');

	return (
		<Property title={t('common.settings.evaluationForms.properties.filledInBy.title')}>
			<Flex alignItems="center">
				<Party
					checked={
						field.value === graphql.EvaluationFillInBy.Employee ||
						field.value === graphql.EvaluationFillInBy.Both
					}
					onChange={() => {
						switch (field.value) {
							case graphql.EvaluationFillInBy.Employee:
								setValue(graphql.EvaluationFillInBy.Manager);
								break;
							case graphql.EvaluationFillInBy.Manager:
								setValue(graphql.EvaluationFillInBy.Both);
								break;
							case graphql.EvaluationFillInBy.Both:
								setValue(graphql.EvaluationFillInBy.Manager);
								break;
						}
					}}
					title={t('common.settings.evaluationForms.properties.filledInBy.employee')}
					name="employee"
				/>
				<Box width={20} />
				<Party
					checked={
						field.value === graphql.EvaluationFillInBy.Manager ||
						field.value === graphql.EvaluationFillInBy.Both
					}
					onChange={() => {
						switch (field.value) {
							case graphql.EvaluationFillInBy.Employee:
								setValue(graphql.EvaluationFillInBy.Both);
								break;
							case graphql.EvaluationFillInBy.Manager:
								setValue(graphql.EvaluationFillInBy.Employee);
								break;
							case graphql.EvaluationFillInBy.Both:
								setValue(graphql.EvaluationFillInBy.Employee);
								break;
						}
					}}
					title={t('common.settings.evaluationForms.properties.filledInBy.manager')}
					name="manager"
				/>
			</Flex>
		</Property>
	);
}
